import { formatMaxUploadSize } from '@lib/shared/constants/max-upload-size';

export function fileSizeLimitMessage(sizeBytes: number): string {
  const sizeMb = (sizeBytes / (1024 * 1024)).toFixed(1);
  return `File size (${sizeMb} MB) exceeds the ${formatMaxUploadSize()} upload limit`;
}
